import script from "./MPropertySummary.vue?vue&type=script&setup=true&lang=js"
export * from "./MPropertySummary.vue?vue&type=script&setup=true&lang=js"

import "./MPropertySummary.vue?vue&type=style&index=0&id=4fcb4ba1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fcb4ba1"]])

export default __exports__